/* eslint-disable class-methods-use-this */
import axios from "axios";

import {
  API_CUSTOMER_FEE_URL,
  API_ORDER_VERIFICATION_URL,
  COMMON_HEADER_CONFIG
} from "../config";

class OrderVerificationService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getOrderVerification = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule`,
        params: {
          limit: 100,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneOrderVerification = (feeid) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule/${feeid}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOrderVerificationFailedDelivery = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule`,
        params: {
          limit: 100,
          page: 1,
          type_rule: "FAILED_DELIVERY"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOrderVerificationDuplicated = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule`,
        params: {
          limit: 100,
          page: 1,
          type_rule: "DUPLICATED"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOrderVerificationHighValue = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule`,
        params: {
          limit: 100,
          page: 1,
          type_rule: "HIGH_VALUE"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOrderVerificationCustomer = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule`,
        params: {
          limit: 100,
          page: 1,
          type_rule: "CUSTOMER"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  addOrderVerificationFailedDelivery = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = data;
      dataCreate.platform_key = "centralweb";

      const config = {
        method: "post",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  addOrderVerificationDupcated = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = data;
      dataCreate.platform_key = "centralweb";

      const config = {
        method: "post",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  addOrderVerificationHighValue = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = data;
      dataCreate.platform_key = "centralweb";

      const config = {
        method: "post",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  addOrderVerificationCustomer = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = data;
      dataCreate.platform_key = "centralweb";

      const config = {
        method: "post",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateOrderVerification = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "PUT",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getCustomerFeeById = (feeId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CUSTOMER_FEE_URL}/customer-fee/${feeId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteOrderVerification = (feeId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule/${feeId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteOrderVerificationDuplication = (feeId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule/${feeId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteOrderVerificationHighValue = (feeId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_ORDER_VERIFICATION_URL}/ov-rule/${feeId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const orderVerificationService = new OrderVerificationService();

export default orderVerificationService;
